module.exports = __webpack_public_path__ + "img/02.9f8827ad.png";